<template>
  <div class="wrapper">
    <div class="result">
        <div class="order-id">订单编号：{{order_id}}</div>
        <div class="order-time">下单时间：{{orderTime}}</div>
        <div class="list-head order-box">
          <div class="order-list">订单详情</div>
        </div>
        <div class="order-box list-box">
          <div class="order-list">
              <DesTable v-if="orderInfo.mark&&orderInfo.customized_status>=4" :price="orderInfo.order_amount" :configstr="orderInfo.mark" :file_path="orderInfo.file_path"></DesTable>
          </div>
        </div>
    </div>

      <div class="a-box money">
          <span class="a-label top10">留言：</span>
          <div class="a-main">
              <!-- :readonly="type==1" -->
              <input  :disabled="true"  v-model="mark" class="a-price-input">

          </div>
      </div>

      <div class="a-box money">
          <span class="a-label top10">可退款金额：</span>
          <div class="a-main">
              <!-- :readonly="type==1" -->
              <input type="number" :disabled="true"  v-model="refund" class="a-price-input">

          </div>
      </div>
      <div class="flex">
          <div class="submit" @click="dialogFormVisible = true">寄出物料</div>

          <div class="submit" ><router-link :to="{name:'currefundApply',params:{order_id:orderInfo.order_id}}">退回重新申请</router-link></div>
      </div>

      <el-dialog title="快递信息" :visible.sync="dialogFormVisible">
          <el-form :model="form">

              <el-form-item label="快递公司" >
                  <el-select v-model="form.region" placeholder="请选择快递公司">
                      <el-option v-for="kuaidi_option in kuaidi_options" :label="kuaidi_option.label" :value="kuaidi_option.value"></el-option>
                  </el-select>
              </el-form-item>
              <el-form-item label="快递单号" >
              <el-input v-model="form.id" autocomplete="off"></el-input>
              </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="kuaidi()">确 定</el-button>
          </div>
      </el-dialog>


      <el-dialog title="留言" :visible.sync="dialogFormVisible2">
          <el-form :model="form2">

              <el-input
                      type="textarea"
                      :rows="2"
                      placeholder="退款金额有误"
                      v-model="form2.textarea">
              </el-input>
          </el-form>
          <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible2 = false">取 消</el-button>
              <el-button type="primary" @click="noallow()">确 定</el-button>
          </div>
      </el-dialog>


  </div>
</template>

<script>
import { timeToDate, formatMoney} from "@/utils";
import {apiBaseUrl} from "@/config/env.js";
import DesTable from '@/components/zqtool/DesTable.vue';
export default {
  name: "currefundApply2",
  components: {DesTable},
  props: {},
  data() {
    return {
        form:{
            region:"",
            id:"",
        },
        form2:{
            textarea:"退款金额有误"
      },
        dialogFormVisible:false,
        dialogFormVisible2:false,
      order_id: "",
      orderTime: "",
      type: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      isDisabled: false, //是否禁用退货
      items: [], //商品列表
      refund: 0, //退款价格
      refund_show: 0, //可输入最大退款金额
      reason: "", //退款原因
        mark:"",
      images: [],
        reship_id:"",
        kuaidi_type:"",
      upLoadUrl: apiBaseUrl + "api.html",
      listData:{},
      orderInfo:{},
        kuaidi_options: [{
            value: '中国邮政',
            label: '中国邮政'
        },{
            value: '圆通速递',
            label: '圆通速递'
        },{
            value: '申通快递',
            label: '申通快递'
        },{
            value: '中通快递',
            label: '中通快递'
        },{
            value: '顺丰速运',
            label: '顺丰速运'
        },{
            value: '天天快递',
            label: '天天快递'
        },{
            value: '韵达快递',
            label: '韵达快递'
        },{
            value: '宅急送',
            label: '宅急送'
        },{
            value: '百世快递',
            label: '百世快递'
        },{
            value: '优比速',
            label: '优比速'
        }
            ]
    };
  },
  watch: {},
  computed: {
    moneyData () {
      if(this.listData.order_amount) {
        return formatMoney((this.listData.order_amount - this.listData.refunded), 2, '');
      }
    },
    item_ids () {
      let selectItems = this.items.filter(item => {
        return item.checked;
      });
      let item_ids = [];
      if (this.type == 1) {
        selectItems.forEach(item => {
          item_ids.push({
            id: item.id,
            // nums: item.nums,
            nums: item.returnNums

          });
        });
      } else {
        selectItems.forEach(item => {
          if (item.sendnums > item.reship_nums) {
            let nums = item.sendnums - item.reship_nums;
            console.log(nums)
            item_ids.push({
              id: item.id,
              // nums: item.nums,
              nums: item.returnNums
            });
          }
        });
      }
      return item_ids;
    }
  },
  methods: {
      noallow(){
          if (!this.form2.textarea) {
              return this.$msg("请填写留言", "warning");
          }
          this.$api.sendShip(data).then(res => {
              if (res.status) {
                  this.$msg("提交成功");
                  this.$router.go(-1);
              } else {
                  this.$msg(res.msg, "error");
              }
          });
      },
      kuaidi(){
          if (!this.form.region) {
              return this.$msg("请填写快递公司名称", "warning");
          }
          if (!this.form.id) {
              return this.$msg("请填写快递单号", "warning");
          }
          let data = {

                  reship_id: this.reship_id,
                  logi_code: this.form.region,
                  logi_no: this.form.id,

              order_id: this.order_id,
          };
          this.$api.sendShip(data).then(res => {
              if (res.status) {
                  this.$msg("提交成功");
                  this.$router.go(-1);
              } else {
                  this.$msg(res.msg, "error");
              }
          });
      },
    //上传图片
    handleExceedVisio() {
      this.$message.warning(`当前限制选择 1 个文件，请删除后继续上传！`)
    },
    //上传图片
    handleUpload(e) {
      var formdata = new FormData();
      formdata.append("upfile", e.file, e.file.name);
      this.$api.uploadImage(this.upLoadUrl, formdata).then(res => {
        if (res.status) {
          this.images = this.images.concat(res.data.image_id);
        } else {
          this.$msg(res.msg, "error");
        }
      });
    },
    handleSubmit() {


      let data = {
        order_id: this.order_id,
        type: this.type,
        items: this.item_ids,
        images: this.images,
        refund: this.refund,
        reason: this.reason
      };
      this.$api.addAfterSales(data).then(res => {
        if (res.status) {
          this.$msg("提交成功");
          this.$router.go(-1);
        } else {
              this.$msg(res.msg, "error");
          }
      });
    },
    radioChange(val) {
      console.log(val)
      this.refund = this.refund_show;
    },
    changeSelected(item, index) {
      if (item.checked) {
        this.items[index].checked = false;
      } else {
        this.items[index].checked = true;
      }
    },
      handleRemove(file, fileList) {
          console.log(file, fileList);
          this.images = [];
      },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //获取订单商品信息
    getOrderInfo() {
      let data = {
        order_id: this.order_id
      };
      this.$api.orderDetail(data).then(res => {
        if (res.status) {
          //如果不是未支付的，已取消的，已完成的状态，就都可以售后
          if (
            res.data.text_status != 1 &&
            res.data.text_status != 6 &&
            res.data.text_status != 7
          ) {
            this.refund = (res.data.refunded).toFixed(2);
            this.orderTime = timeToDate(res.data.ctime);
            this.orderInfo=Object.assign({},this.orderInfo,res.data);
            if(this.orderInfo&&this.orderInfo.bill_aftersales_id){
                this.getAfterSaleInfo(this.orderInfo.bill_aftersales_id);
            }
          } else {
            this.$msg("订单不可以进行售后", "error");
          }
          this.listData = res.data
        } else {
          this.$msg("没有找到此订单", "error");
        }
      });
    },
      getAfterSaleInfo(aftersales_id) {
          let data = {
              aftersales_id: aftersales_id
          };
          this.$api.afterSalesInfo(data).then(res => {
              if (res.status) {
                if(res.data&&res.data.info&&res.data.info.bill_reship&&res.data.info.bill_reship.reship_id){
                    this.reship_id = res.data.info.bill_reship.reship_id;
                }
                  this.mark=res.data.info.mark;

              }
          });
      }
  },
  created() {},
  mounted() {
    let order_id = this.$route.params.order_id;
    this.order_id = order_id;
    this.getOrderInfo();
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/variable.scss";
.flex{ display: flex}
.result {
  margin-bottom: 20px;
}
.order-id, .order-time {
  margin-bottom: 10px;
}
.order-box {
  display: flex;
  text-align: center;
  align-items: center;
  &.list-head {
    height: 40px;
    line-height: 40px;
    background: $theme-bg;
  }
  &.list-box {
    border-bottom: 1px solid $border;
    // border-top: none;
    // border-left: 0;

    .order-list {
      display: inline-flex;
      border-left: 1px solid $border;
      border-right: 1px solid $border;
      padding: 20px 0;
      display: flex;
      flex-direction: column;
      .product-item {
        // margin: 0 10px;
        padding: 0 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        border-bottom: 1px solid #eee;
        padding: 10px;
        &:last-child {
          border: none;
        }
        .product-img {
          display: inline-block;
          width: 50px;
          height: 50px;
          flex: 0 0 50px;
          object-fit: cover;
          // margin-bottom: 10px;
        }
        .shop-info {
          display: flex;
          flex-direction: column;
          flex: 1;
          padding: 0 20px;
          align-items: flex-start;
          text-align: left;
          font-size: 12px;
          .title {
            width: 700px;
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            margin-bottom: 10px;
          }
          .desc {
            input {
              border: 1px solid #eee;
              width: 40px;
              height: 24px;
              text-align: center;
            }
          }
        }
        .apply-btn {
          width: 50px;
          height: 20px;
          line-height: 20px;
          border: 1px solid $border;
          cursor: pointer;
          color: $theme-color;
          font-size: 12px;
          flex: 0 0 50px;
          &.active {
            background: $theme-color;
            color: #fff;
          }
          &:hover {
            background: $theme-color;
            color: #fff;
          }
        }
      }
    }
  }
  .order-id {
    width: 200px;
  }
  .order-list {
    flex: 1;
  }
  .order-time {
    width: 200px;
  }
}
.a-box {
  display: flex;
  margin-bottom: 10px;
  padding: 8px 0;
  &.money {
    .a-main {
      display: flex;
      flex-direction: column;
      .desc {
        font-size: 12px;
        margin-top: 10px;
      }
    }
  }
  .a-label {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 20px;
    &.top10 {
      margin-top: 10px;
    }
  }
  .a-main {
    display: inline-flex;
    .a-img {
      width: 75px;
      height: 75px;
      display: inline-block;
      object-fit: cover;
      margin-right: 20px;
    }
    .a-name {
      display: inline-block;
    }
    .a-price-input {
      display: block;
      width: 180px;
      height: 30px;
      text-indent: 10px;
      color: $theme-color;
      font-size: 16px;
      border: 1px solid $border;
    }
    .textarea {
      width: 480px;
      resize: none;
      border: 1px solid $border;
      padding: 10px;
      &:focus {
        outline: none;
        border-color: $theme-color;
      }
    }
  }
}
.submit {
  width: 200px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: $theme-color;
  color: #fff;
  margin-left: 120px;
  margin-top: 30px;
  cursor: pointer;
}
.radio {
  margin-right: 10px;
}
  .Excelicon{ width: 150px; cursor: pointer}
::v-deep .el-dialog__body{padding: 30px 20px !important;}
</style>